import HystModal from 'hystmodal';

// export const enterEmailModal = new HystModal({
//     linkAttributeName: "data-open-create-account-modal",
// });

export const enterEmailModal = new HystModal({
    linkAttributeName: 'data-open-create-account-modal',
    catchFocus: true,
    waitTransitions: true,
    closeOnEsc: true,
});